//菜单配置
var menus = [
    // {
    //     icon:"el-icon-menu",
    //     title:"测试版块",
    //     children:[
    //         {title:"首页",routername:'tLogPlanList'},
    //         {title:"模块配置",routername:'rolelist'},
    //         {title:"测试tab",routername:'home.test'}
    //     ]
    // },
	{
		icon:"el-icon-menu",
		title:"系统配置",
		children:[
			{title:"用户管理",routername:'userlist'},
			{title:"角色配置",routername:'rolelist'}
		]
	},
    {
        icon:"el-icon-document",
        title:"主表管理",
		children:[
			{title:"品目基础信息",routername:'mGradeList'},
			{title:"品目库存月度安全系数维护",routername:'mStockSafeRatioList'},
			{title:"品目颜色批注维护",routername:'mGradeCommentList'},
			{title:"客户基础信息",routername:'mCustomerList'},
			{title:"客户品目对应信息维护",routername:'mCustomerGradeList'},
			{title:"客户码头对应信息维护",routername:'mCustomerYardList'},
			{title:"客户品名对应车间维护",routername:'mCustomerGradePlantList'},
			{title:"产线主表维护",routername:'mPlantLineList'},
			{title:"车间产能系数期间维护",routername:'mProductionRatioList'},
			{title:"代码维护",routername:'mCodeList'},
			{title:"排程规则",routername:'mGradeRuleList'},
			{title:"工厂日历",routername:'mFactoryCalendarList'},
			{title:"产线工作日历",routername:'mLineCalendarList'},
			{title:"库存对应关系维护",routername:'mStockPackageList'}
		]
    },
    {
        icon:"el-icon-goods",
        title:"库存管理",
		children:[
			{title:"盘点库存导入",routername:'tTanaStockList'},
			{title:"实时库存查询",routername:'tRealtimeStockList'},
			{title:"理论期初库存查询",routername:'tPeriodStockList'},
			{title:"充填实绩查询",routername:'tRealtimeFillinList'}
		]
    },
	{
		icon:"el-icon-s-order",
		title:"需求管理",
		children:[
			{title:"销售订单查询",routername:'vSalesOrderList'},
			{title:"销售预测登录",routername:'tForecastSalesMonthList'},
			{title:"年度销售预测",routername:'tForecastSalesYearList'},
			{title:"需求计划",routername:'tProcessPlanList'}
		]
	},
	{
		icon:"el-icon-s-claim",
		title:"生产计划",
		children:[
			{title:"生产计划排程",routername:'tProcessList'},
			{title:"处理日志查询",routername:'home'},
			{title:"生产计划调整",routername:'tMonthPlanList'},
			{title:"生产计划查询",routername:'tMonthPlanListS'},
			{title:"品目库存推移明细",routername:'tStockStatisticsList'},
			{title:"甘特图",routername:'vGanttList'},
			{title:"年度生产计划表",routername:'vYearBalanceList'},
			{title:"生产平衡表",routername:'vBalanceList'},
			{title:"年度生产计划调整",routername:'tYearPlanList'}
		]
	},
];

menus.forEach((menu1,index1)=>{
    menu1.index=index1.toString();
    if(menu1.children){
        menu1.children.forEach((menu2,index2)=>{
            menu2.index=index1+'.'+index2;
            if(menu2.children){
                menu2.children.forEach((menu3,index3)=>{
                    menu3.index=index1+'.'+index2+'.'+index3;
                })
            }
        })
    }
})


export default menus



// WEBPACK FOOTER //
// ./src/views/menuconfig.js